module.exports = __webpack_public_path__ + "img/goto.0f93ebd2.svg";